import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '& .professional': {
      '&-content': {
        display: 'flex',
        padding: theme.spacing(3, 0, 0),
      },
      '&-icon': {
        color: theme.palette.primary.main,
        fontSize: theme.spacing(6),
        marginRight: theme.spacing(2),
      },
      '&-infos': {
        '&-container': {
          flexDirection: 'column',
          flexGrow: 1,
        },
        '&-box': {
          flexDirection: 'column',
          marginBottom: theme.spacing(3),
          flexGrow: 1,
        },
        '&-label': {
          color: theme.palette.text.hint,
        },
      },
    },
  },
  paper: {
    width: '100%',
  },
}));

export default styles;
